<template>
  <header class="platform-navbar">
    <h1 v-if="title" class="platform-navbar__title">{{ title }}</h1>
    <div v-else class="platform-navbar__spacer" />
    <userInfo variant="platform" />
  </header>
</template>

<script>
import userInfo from '@/components/userInfo.vue';

export default {
  name: 'PlatformNavbar',
  components: { userInfo },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.platform-navbar {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  height: 64px;
  min-height: 64px;
  padding: 0 28px;
  box-sizing: border-box;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 100;
  flex-shrink: 0;
  font-family: 'Manrope', sans-serif;

  &__title {
    flex: 1;
    min-width: 0;
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #111827;
    letter-spacing: -0.3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__spacer {
    flex: 1;
  }

  @media (max-width: 768px) {
    padding: 0 16px;
    height: 56px;
    min-height: 56px;

    &__title {
      font-size: 16px;
    }
  }
}
</style>
